import { withProps } from 'recompose'
import { LOAN_TERM_MESSAGES } from '../../../../../constants/loan'

const fixedTerms = [30, 25, 22, 20, 15, 10]
const adjustableTerms = [10, 7, 5, 3, 1]

export const withTranslatedLoanTerms = withProps(({ intl }) => ({
  termOptions: fixedTerms
    .map(term => ({
      adjustable: false,
      termYears: term,
      value: intl.formatMessage(LOAN_TERM_MESSAGES.fix, { years: term }),
    }))
    .concat(
      adjustableTerms.map(term => ({
        adjustable: true,
        armYearsInitial: term,
        value: intl.formatMessage(LOAN_TERM_MESSAGES.arm, { years: term }),
      }))
    ),
}))
